<script lang="ts">
import { computed } from 'vue';

import { useBreakpointMediaQueries } from '@sg-core/resources/assets/js/composables';

import PhxsgCollectionsBlockAltDesktop from './phxsg-collections-block-alt-desktop.vue';
import PhxsgCollectionsBlockDesktop from './phxsg-collections-block-desktop.vue';
import PhxsgCollectionsBlockMobile from './phxsg-collections-block-mobile.vue';
import PhxsgCollectionsBlockStaticDesktop from './phxsg-collections-block-static-desktop.vue';

import type { PhxsgPictureProps } from '../../Atoms/Picture';

export interface CollectionsBlockItem {
  title: string;
  text?: string;
  cta?: {
    label: string;
    href: string;
  };
  picture?: PhxsgPictureProps;
  bigPicture: PhxsgPictureProps;
  thumbnail: PhxsgPictureProps;
}

export interface PhxsgCollectionsBlockProps {
  items?: CollectionsBlockItem[];
  title?: string;
  variant?: 'default' | 'alt' | 'static';
}
</script>

<script setup lang="ts">
const { items = [], title, variant = 'default' } = defineProps<PhxsgCollectionsBlockProps>();

const activeBreakpoint = useBreakpointMediaQueries(['lg']);
const isDesktop = computed(() => activeBreakpoint.value === 'lg');
const isAltLayout = computed(() => variant === 'alt' || variant === 'static');
</script>

<template>
  <template v-if="isAltLayout">
    <PhxsgCollectionsBlockStaticDesktop v-if="isDesktop && variant === 'static'" :items="items" />
    <PhxsgCollectionsBlockAltDesktop v-else-if="isDesktop" :items="items" />
    <PhxsgCollectionsBlockMobile v-else :items="items" alt />
  </template>

  <template v-else>
    <PhxsgCollectionsBlockDesktop v-if="isDesktop" :items="items" :title="title" />
    <PhxsgCollectionsBlockMobile v-else :items="items" />
  </template>
</template>

<style src="./collections-block.css" />
